import Select from "react-select";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCrown} from "@fortawesome/free-solid-svg-icons";
import {OWNER_ROLE_VALUE} from "./projectRoleOptions.js";

const styles = {
    menuPortal: base => ({...base, zIndex: 9999}),
    control: (base, state) => ({
        ...base,
        minHeight: 40,
        borderRadius: 8,
        borderColor: state.isFocused ? '#8b5cf6' : '#cbd5e1',
        boxShadow: 'none',
        '&:hover': {borderColor: '#8b5cf6'},
    }),
    singleValue: base => ({...base, textAlign: 'left'}),
    menu: base => ({...base, borderRadius: 10, overflow: 'hidden'}),
};

export default function ProjectRoleSelect({options, value, onChange, disabled = false}) {
    return <Select
        menuPortalTarget={document.body}
        className="datixo_select_container min-w-0 flex-1 text-sm lg:w-full"
        classNamePrefix="datixo_select"
        styles={styles}
        options={options}
        value={value}
        onChange={onChange}
        isDisabled={disabled}
        formatOptionLabel={(option) => <div className="flex items-center justify-start gap-2">
            {option.value === OWNER_ROLE_VALUE && <FontAwesomeIcon icon={faCrown} className="text-violet-600"/>}
            <span>{option.label}</span>
        </div>}
    />;
}
